import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, MaybeAsync, RedirectCommand, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { ReferralInfoApiService } from "../../service/referral-info-api.service";
import { ReferralInfoDetails, ReferralInfoTabsMeta } from "../referral-info.model";

@Injectable({ providedIn: 'root' })
export class ReferralInfoTabResolver implements Resolve<Observable<ReferralInfoTabsMeta | null>> {

    private apiService = inject(ReferralInfoApiService);

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<Observable<ReferralInfoTabsMeta | null> | RedirectCommand> {
        const caseSequenceNumber = route.paramMap.get('sequeceNumber') || '0';

        if (!caseSequenceNumber) {
            return of(null);
        }
        return this.apiService.getReferralInfoTabDetails(+caseSequenceNumber);
    }

}


@Injectable({ providedIn: 'root' })
export class ReferralInfoDetailsResolver implements Resolve<Observable<ReferralInfoDetails | null>> {

    private apiService = inject(ReferralInfoApiService);

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<Observable<ReferralInfoDetails | null> | RedirectCommand> {
        const caseSequenceNumber = route.paramMap.get('sequeceNumber') || '0';

        if (!caseSequenceNumber) {
            return of(null);
        }
        return this.apiService.getReferralInfo(+caseSequenceNumber);
    }

}